export default "__VITE_ASSET__BHDfT1FB__"